import React, { useState } from "react";
import { Copyright, Home } from "@mui/icons-material";
import RegisterBookContent from "../../../../../components/reg_book/RegisterBookContent";
import { useGetRegBookCopyrightQuery } from "../../../../../redux/api/submittedCopyrightAgreementApiSlice";
import Loader from "../../../../../components/custom/Loader";
import CopyrightTable from "../../../../../components/reg_book/CopyrightTable";

const IndexerBookCopyright = () => {
  const bookType = 1;
  const [regNo, setRegNo] = useState("");
  const [trackReg, setTrackReg] = useState("");
  const { data, isLoading } = useGetRegBookCopyrightQuery({
    bookType,
    trackReg,
    indexBook: true,
    registration_no: regNo,
  });
  const breadcrumbsData = [
    { icon: Home, title: "হোম", url: "/" },
    {
      icon: Copyright,
      title: "কপিরাইট - ইনডেক্স রেজিস্টার বুক",
      active: true,
    },
  ];
  const applicationPath = {
    copyright: "/admin/indexer-register-book-copyright",
    agreement: "/admin/indexer-register-book-agreement",
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <RegisterBookContent
      data={data}
      trackReg={trackReg}
      setTrackReg={setTrackReg}
      regNo={regNo}
      setRegNo={setRegNo}
      showRegNo={true}
      content={<CopyrightTable data={data} />}
      breadcrumbsData={breadcrumbsData}
      applicationPath={applicationPath}
    />
  );
};

export default IndexerBookCopyright;
